import { render, staticRenderFns } from "./ReferralHero.vue?vue&type=template&id=b842f308&scoped=true&"
import script from "./ReferralHero.vue?vue&type=script&lang=js&"
export * from "./ReferralHero.vue?vue&type=script&lang=js&"
import style0 from "./ReferralHero.vue?vue&type=style&index=0&id=b842f308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b842f308",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReferralStartEarningBtn: require('/opt/render/project/src/channels2022/src/components/referral/ReferralStartEarningBtn.vue').default})
